import React from 'react';
import Homepage from './Homepage';
import Layout from '../components/layout';
import SEO from '../components/seo';
import './index.css';

const IndexPage = () => {
    return (
        <Layout>
            <SEO />
            <Homepage />
        </Layout>
    );
};

export default IndexPage;
